export default "__VITE_ASSET__B38kfc2m__"